import React from 'react';
import { AppSidebar } from '@nsi-advisory-services/components';
import useAuthSession from '../../auth/useAuthSession';
import { useHasConnectSuite } from '../../hooks/useQueries';
import { useTheme } from '../../theme/ThemeProvider';
import useNavItems from './navItems';

const SUITE_APPS = [
  {
    key: 'bdc',
    label: 'BizDev Connect',
    href: 'https://bizdevconnect.nsieng.com/',
    iconImageSrc: '/res/biz_dev_connect_logo.png',
    icon: 'bi-grid',
  },
  {
    key: 'ppc',
    label: 'ProPlan Connect',
    href: '/',
    iconImageSrc: '/res/ppc.png',
    icon: 'bi-kanban',
    current: true,
  },
  {
    key: 'pc',
    label: 'Pursuit Connect',
    href: 'https://pursuitconnect.nsieng.com/',
    iconImageSrc: '/res/pc_logo_192.png',
    icon: 'bi-briefcase',
  },
  {
    key: 'riims',
    label: 'RIIMS',
    href: 'https://riimsapp.nsieng.com/',
    iconImageSrc: '/res/riims_logo_512.png',
    icon: 'bi-graph-up-arrow',
  },
  {
    key: 'ems',
    label: 'Employee Connect',
    href: 'https://employeeconnect.nsieng.com/',
    iconImageSrc: '/res/employee_connnect_logo_transparent.png',
    icon: 'bi-people',
  },
  {
    key: 'h9',
    label: 'H9 Online',
    href: 'https://h9online.nsieng.com',
    iconImageSrc: '/res/h9_logo.png',
    icon: 'bi-lightning-charge',
  },
];

export default function Sidebar({ collapsed, onToggle }) {
  const { isSignedIn, isLoading, displayName, signIn, signOut } = useAuthSession();
  const { isDark, toggleTheme } = useTheme();
  const hasConnectSuite = useHasConnectSuite({ enabled: isSignedIn });
  const items = useNavItems();

  return (
    <AppSidebar
      collapsed={collapsed}
      onToggle={onToggle}
      appName="ProPlanConnect"
      logoSrc="/logo512.png"
      items={items}
      apps={hasConnectSuite ? SUITE_APPS : []}
      theme={{ isDark, onToggle: toggleTheme }}
      user={isSignedIn ? { name: displayName } : null}
      userLoading={isLoading}
      onSignIn={signIn}
      onSignOut={signOut}
    />
  );
}
